// Module
var code = "<h1 id=\"calendar---events\">Calendar - Events</h1> <p>Empty (edit)</p> ";
// Exports
module.exports = code;